import { SvgIcon, SvgIconProps } from '@material-ui/core';
import React, { FC } from 'react';

export const ExternalLink: FC<SvgIconProps> = props => (
  <SvgIcon {...props}>
    <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1V6H2V2H6V0H1C0.4 0 0 0.4 0 1Z" />
      <path d="M10 16H15C15.6 16 16 15.6 16 15V10H14V14H10V16Z" />
      <path d="M9 0V2H12.6L9.3 5.3L10.7 6.7L14 3.4V7H16V0H9Z" />
      <path d="M1 16H6V14H2V10H0V15C0 15.6 0.4 16 1 16Z" />
    </svg>
  </SvgIcon>
);
